import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Communitysection from '../components/Communitysection';
const Community = () => {
    return (
        <div>
            <Header />
            <Communitysection />
            <Footer />
        </div>
    );
};

export default Community;